var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_3678_16747)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3678_16747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5001 36.001H48.5007C41.9014 36.001 36.501 41.4014 36.501 48.0007V72.0013C36.501 78.5988 41.9014 84.001 48.5007 84.001H72.5001C79.0993 84.001 84.4998 78.5988 84.4998 72.0013V48.0007C84.4998 41.4014 79.0993 36.001 72.5001 36.001ZM80.4997 72.0013C80.4997 76.4112 76.9124 80.0009 72.5001 80.0009H48.5007C44.0902 80.0009 40.5011 76.4112 40.5011 72.0013V48.0007C40.5011 43.5896 44.0902 40.0011 48.5007 40.0011H72.5001C76.9124 40.0011 80.4997 43.5896 80.4997 48.0007V72.0013Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5019 49.9999C75.1587 49.9999 76.5018 48.6567 76.5018 46.9999C76.5018 45.3431 75.1587 44 73.5019 44C71.8451 44 70.502 45.3431 70.502 46.9999C70.502 48.6567 71.8451 49.9999 73.5019 49.9999Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4997 48C53.871 48 48.5 53.3716 48.5 59.9997C48.5 66.6253 53.871 72.0006 60.4997 72.0006C67.1265 72.0006 72.4994 66.6253 72.4994 59.9997C72.4994 53.3716 67.1265 48 60.4997 48ZM60.4997 68.0005C56.082 68.0005 52.5001 64.4186 52.5001 59.9997C52.5001 55.5808 56.082 52.0001 60.4997 52.0001C64.9174 52.0001 68.4993 55.5808 68.4993 59.9997C68.4993 64.4186 64.9174 68.0005 60.4997 68.0005Z",
    fill: "#A9A9A9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 3.75C91.5163 3.75 116.75 28.9837 116.75 60C116.75 91.0163 91.5163 116.25 60.5 116.25C29.4837 116.25 4.25 91.0163 4.25 60C4.25 28.9837 29.4837 3.75 60.5 3.75ZM60.5 0C27.365 0 0.5 26.865 0.5 60C0.5 93.135 27.365 120 60.5 120C93.635 120 120.5 93.1387 120.5 60C120.5 26.8612 93.635 0 60.5 0Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3678_16747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3678_16747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.9999,
    height: 48,
    fill: "white",
    transform: "translate(36.5 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaEmpty);
export default __webpack_public_path__ + "static/media/instaEmpty.ac4da02f1a35cf32bd0e2f53087a27e3.svg";
export { ForwardRef as ReactComponent };